// extracted by mini-css-extract-plugin
module.exports = {"ironData":"IronData_ironData__1IKGs"};